import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RanchoIndexComponent } from './rancho-index/rancho-index.component';
import { RanchosImportComponent } from './ranchos-import/ranchos-import.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RanchoRoutingModule } from './rancho-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RanchosSolicitudesComponent } from './ranchos-solicitudes/ranchos-solicitudes.component';
import { VisorRemitosComponent } from './visor-remitos/visor-remitos.component';
import { VisorRanchosRemitosComponent } from './visor-ranchos-remitos/visor-ranchos-remitos.component';
import { RanchosRemitosDetalleComponent } from './ranchos-remitos-detalle/ranchos-remitos-detalle.component';
import { ModalAsignarRanchoComponent } from './ranchos-solicitudes/modal-asignar-rancho/modal-asignar-rancho.component';
import { ModalBitacoraRanchoComponent } from './ranchos-solicitudes/modal-bitacora-rancho/modal-bitacora-rancho.component';
import { ModalMarcarRanchoComponent } from './ranchos-solicitudes/modal-bitacora-rancho/modal-marcar-rancho/modal-marcar-rancho.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { SharedModule } from '@shared/shared.module';
import { ModalAdjuntosComponent } from './ranchos-solicitudes/modal-adjuntos/modal-adjuntos.component';
import { ModalModificarAerovaleComponent } from './modal-modificar-aerovale/modal-modificar-aerovale.component';


@NgModule({
  declarations: [
    RanchoIndexComponent,
    RanchosImportComponent,
    RanchosSolicitudesComponent,
    RanchosRemitosDetalleComponent,
    VisorRemitosComponent,
    VisorRanchosRemitosComponent,
    ModalAsignarRanchoComponent,
    ModalBitacoraRanchoComponent,
    ModalMarcarRanchoComponent,
    ModalAdjuntosComponent,
    ModalModificarAerovaleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RanchoRoutingModule,
    NgbModule,
    NgxSpinnerModule,
    SharedModule,
    InfiniteScrollDirective
  ]
})
export class RanchoModule { }
